import { fetchProducts as fetchProductsHTTPRequest } from './../utils/api';

export const FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_REQUEST';
export const FETCH_PRODUCTS_RECEIVE = 'FETCH_PRODUCTS_RECEIVE';
export const FETCH_PRODUCTS_ERROR = 'FETCH_PRODUCTS_ERROR';

const productsReceived = products => {
  const allActiveProducts = (products || []).filter(
    product => product.status === 2
  );
  return {
    type: FETCH_PRODUCTS_RECEIVE,
    products: allActiveProducts,
  };
};

export const fetchProducts = group => async dispatch => {
  try {
    dispatch({
      type: FETCH_PRODUCTS_REQUEST,
    });

    const productResponse = await fetchProductsHTTPRequest(group);
    dispatch(productsReceived(productResponse));
  } catch (error) {
    dispatch({
      error,
      type: FETCH_PRODUCTS_ERROR,
    });
  }
};
